import React, { useState } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { NumericForecastImage } from 'helper/products/meteorology';
import { cssVar } from 'constants/theme';

import './index.scss';

const ZOOM_STEP = 0.2;
const ZOOM_MIN = 0.6;
const ZOOM_MAX = 2;

export default function SingleMap({ image }: { image: NumericForecastImage | undefined }) {
  const [zoom, setZoom] = useState(1);

  return (
    <div className="tf-pnt-mobile-single-map">
      <div className="tf-pnt-mobile-single-map-frame">
        {image ? (
          <img
            src={`data:image/png;base64,${image.base64}`}
            alt={`Mapa ${image.model}`}
            style={{ transform: `scale(${zoom})` }}
          />
        ) : (
          <p className="tf-pnt-mobile-single-map-empty">Nenhuma imagem disponível para este modelo.</p>
        )}
      </div>
      <div className="tf-pnt-mobile-single-map-zoom">
        <button
          type="button"
          aria-label="Diminuir zoom"
          className="tf-pnt-mobile-single-map-zoom-button"
          onClick={() => setZoom((z) => Math.max(ZOOM_MIN, Number((z - ZOOM_STEP).toFixed(1))))}
        >
          <Icon iconType="remove" color={cssVar('text-muted')} size="small" />
        </button>
        <span className="tf-pnt-mobile-single-map-zoom-label">
          {Math.round(zoom * 100)}
          %
        </span>
        <button
          type="button"
          aria-label="Aumentar zoom"
          className="tf-pnt-mobile-single-map-zoom-button tf-pnt-mobile-single-map-zoom-button--primary"
          onClick={() => setZoom((z) => Math.min(ZOOM_MAX, Number((z + ZOOM_STEP).toFixed(1))))}
        >
          <Icon iconType="add" color={cssVar('text-on-accent')} size="small" />
        </button>
      </div>
    </div>
  );
}
